<template lang="pug">
a.text-accent(v-if="linkValue", :href="linkValue.href") {{ linkValue.label }}
p.whitespace-pre-wrap(v-else)
  | -
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  isLinkPropertyValue,
  type LinkPropertyValue,
} from "@shared/services/twinManagement";

const props = defineProps<{
  value?: unknown;
}>();

const linkValue = computed(() => {
  const value = props.value;
  if (!isLinkPropertyValue(value)) {
    return undefined;
  }

  const link: LinkPropertyValue = value;
  if (!link.protocol || !link.path) {
    return undefined;
  }
  return {
    href: `${link.protocol}:${link.protocol.startsWith("http") ? "//" : ""}${link.path}`,
    label: link.label || link.path || "-",
  };
});
</script>
